import type {RelayCompat} from '@github-ui/server-persisted-queries/relay-compat'
import {MilestoneIcon} from '@primer/octicons-react'

import {LABELS} from '../constants/labels'
import {createIssueEventExternalUrl} from '../utils/urls'
import {type DemilestonedEventFragment, getWrappedMilestoneLink} from './DemilestonedEvent'
import type {MilestonedEventNode} from './issue-viewer-page-query-types'
import {RolledupMilestonedEvent} from './RolledupMilestonedEvent'
import {TimelineRow} from './row/TimelineRow'

// RELAY-CLEANUP(MilestonedEvent): widens nullable fields so still-Relay parent data is assignable.
// Remove when the parent timeline query leaves Relay.
export type MilestonedEventFragment = RelayCompat<
  Pick<MilestonedEventNode, 'actor' | 'createdAt' | 'databaseId' | 'milestone' | 'milestoneTitle'>
>

type MilestonedEventProps = {
  queryRef: MilestonedEventFragment
  issueUrl: string
  onLinkClick?: (event: MouseEvent) => void
  highlightedEventId?: string
  refAttribute?: React.RefObject<HTMLLIElement | null>
  rollupGroup?: Record<string, Array<MilestonedEventFragment | DemilestonedEventFragment>>
}

export function MilestonedEvent({
  queryRef,
  issueUrl,
  onLinkClick,
  highlightedEventId,
  refAttribute,
  rollupGroup,
}: MilestonedEventProps): React.ReactElement {
  const {actor, createdAt, milestoneTitle, milestone, databaseId} = queryRef
  const highlighted = String(databaseId) === highlightedEventId

  return (
    <TimelineRow
      highlighted={highlighted}
      refAttribute={refAttribute}
      actor={actor}
      createdAt={createdAt}
      deepLinkUrl={createIssueEventExternalUrl(issueUrl, databaseId)}
      onLinkClick={onLinkClick}
      leadingIcon={MilestoneIcon}
    >
      <TimelineRow.Main>
        {rollupGroup ? (
          <RolledupMilestonedEvent rollupGroup={rollupGroup} />
        ) : (
          <>
            {LABELS.timeline.addedToMilestone} {getWrappedMilestoneLink(milestone?.url, milestoneTitle)}
            {LABELS.timeline.milestone}{' '}
          </>
        )}
      </TimelineRow.Main>
    </TimelineRow>
  )
}
